/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class WarehouseTransactionTransformer extends Transformer {

  static fetch(transaction) {
    return {
      id: transaction.id,
      transactionId: transaction.transaction_id,
      code: transaction.code,
      via: transaction.via,
      createdAt: transaction.created_at,
      totalQty: transaction.total_qty,
      status: transaction.status,
    };
  }

  static send(transaction) {
    return {
      id: transaction.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouseTransaction.js